import { LitElement, html, nothing } from 'lit';

class Badges extends LitElement {
  static properties = {
    tags: { type: Array },
    productId: { type: String, attribute: 'product-id' },
  };

  constructor() {
    super();
    this.tags = [];
    this.comingSoon = false;
    this.justDropped = false;
    this.productId = null;
  }

  createRenderRoot() {
    return this;
  }

  render() {
    if (this.justDropped) {
      return html`
        <div class="product-badge">
          ${ window.theme.strings.badgeJustDropped }
        </div>
      `;
    }

    if (this.comingSoon) {
      return html`
        <div class="product-badge">
          ${ window.theme.strings.badgeComingSoon }
        </div>
      `;
    }

    if (!this.tags || !Array.isArray(this.tags)) {
      return nothing;
    }

    const badgeKey = window.theme.getProductBadgeKey?.(this.tags, {
      productId: this.productId,
    });
    const badgeText = window.theme.getProductBadgeText?.(badgeKey);

    if (!badgeText) {
      return nothing;
    }

    return html`
      <div class="product-badge">
        ${badgeText}
      </div>
    `;
  }
}

customElements.define('product-badges', Badges);
